import React from "react";

const LoadingLogo = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 33 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22.0138 3.9071L24.2031 0.114166L26.2697 3.66446L24.072 7.47134L31.1112 19.6617C33.0272 22.9833 31.881 27.2671 28.5594 29.1859C25.2378 31.1019 20.9512 29.9556 19.0352 26.634L17.73 24.3722L19.7882 20.808L22.1225 24.8547C23.054 26.4695 25.1625 27.0328 26.7772 26.1013C28.392 25.1698 28.9554 23.0614 28.0239 21.4466L22.0166 11.0384L24.0776 7.47134L22.0194 3.9071H22.0138ZM19.9332 7.5076L22.011 3.9071C20.7727 1.85724 18.6224 0.666373 16.3746 0.554816H16.3327L16.2212 0.549238H16.1849H16.157H16.0287H16.0176H15.9005H15.8865H15.7889L15.7554 0.552027C13.4323 0.638483 11.1983 1.87676 9.95727 4.02702L0.929527 19.6617C-0.989251 22.9833 0.159785 27.2671 3.48139 29.1859C6.803 31.1019 11.0896 29.9528 13.0056 26.634L18.5722 16.9927L18.6057 16.9341L19.2137 15.8799L21.9887 11.0746L19.9304 7.51039L17.1555 12.3185L16.6451 13.1998L16.5112 13.4285L9.91543 24.8519C8.98393 26.4667 6.87551 27.03 5.26072 26.0985C3.64594 25.167 3.08258 23.0586 4.01408 21.4438L13.0418 5.80914C13.5801 4.87485 14.5116 4.29476 15.5128 4.14695C15.6801 4.12463 15.8503 4.11069 16.0204 4.11069H16.0845H16.0901C16.6395 4.12463 17.1917 4.26687 17.6965 4.55971C18.1539 4.82465 18.5276 5.18442 18.8065 5.59997L19.9277 7.50481L19.9332 7.5076Z"
        fill="url(#paint0_linear_79_33119)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_79_33119"
          x1="12.8661"
          y1="4.57644"
          x2="26.1135"
          y2="28.0034"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F12E11" />
          <stop offset="1" stop-color="#F5AA19" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const LoadingSplash = () => {
  return (
    <div className={"loading-container"}>
      <div
        className="item-card relative flex flex-col justify-center items-center gap-3 w-[160px] sm:w-["
        style={{
          borderRadius: "20px",
          width: "100%",
          maxWidth: "100%",
          minWidth: "150px",
          minHeight: "200px",
          justifyContent: "center",
        }}
      >
        <div className="absolute">
          <div className="opacity-20 max-h-[200px] max-w-[200px]">
            <LoadingLogo />
          </div>
        </div>
        <div className="flex justify-center items-center bg-transparent w-[100px] gap-[6px] relative z-10">
          <div className="circle"></div>
          <div className="circle"></div>
          <div className="circle"></div>
        </div>
      </div>
    </div>
  );
};

export const LoadingSplash2 = () => {
  return (
    <div className="loading-container-2">
        <div>
            <img src={`/assets/images/section-loading-icon.svg`} alt=""/>
            <div className="loading-spin-3" />
        </div>
    </div>
  );
};

export const LoadingList = () => {
  return (
    <div className="loading-list">
        <img src={`/assets/images/section-loading-icon.svg`} alt=""/>
        <div className="loading-spin-3" />
    </div>
  )
}

export const LoadingOverlay = ({ isLoading = false }) => {
  return (
    <div className={"loading-container"}>
      <div
        className="item-card relative flex flex-col justify-center items-center gap-3 w-[160px] sm:w-["
        style={{
          borderRadius: "20px",
          width: "100%",
          maxWidth: "100%",
          minWidth: "150px",
          minHeight: "200px",
          justifyContent: "center",
        }}
      >
        <div className="absolute">
          <div className="opacity-50 max-h-[200px] max-w-[200px]">
            <LoadingLogo />
          </div>
        </div>
        <div className="flex justify-center items-center bg-transparent w-[100px] gap-[6px] relative z-10">
          <div className="circle"></div>
          <div className="circle"></div>
          <div className="circle"></div>
        </div>
      </div>
    </div>
  );
};
